// API
import { api } from './api';

// Types
import { FetchResponseType } from '../../types/Fetch';
import { LeadsCallQueryParamsType } from '../../types/LeadsList';

/**
 * Special fetch method for GET leads for views list by sending query parameters
 *
 * @param params LeadsCallQueryParamsType
 * @param token
 * @returns Promise<FetchResponseType>
 */
export default async function fetchLeads(params: LeadsCallQueryParamsType, token: string): Promise<FetchResponseType> {
    let _url = api.leadsOverview;
    const init = { ...(params as { [key: string]: any }) };
    if (Array.isArray(params.status)) {
        delete init['status'];
    }
    let _query: any = new URLSearchParams(init);

    // we have a special situation with multiple STATUS values
    let _specials = '';
    if (params.status && Array.isArray(params.status)) {
        _specials = '&' + params.status.map((item: string) => `status=${item}`).join('&');
    }

    _url = `${_url}?${_query.toString()}${_specials}`;
    const resp = await fetch(_url, {
        method: 'GET',
        headers: {
            'Accept-Language': 'de-DE',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        },
    });

    return {
        data: resp.status === 200 ? resp.json() : undefined,
        status: resp.status,
        error: resp.status === 200 ? undefined : resp,
    };
}
